import { IApiSuccessWrapper } from '$/types'
import { apiSlice } from 'app/services/api'

export interface IGroupColumnType {
  id: number
  name: string
  order: number
  isActive: boolean
  groupTypeColumns: Array<{
    id: number
    name: string
    isSelected: boolean
  }>
}

export const groupColumnsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getGroupColumnsData: build.query<IGroupColumnType[], void>({
      query: () => ({
        method: 'GET',
        url: '/groupTypes'
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IGroupColumnType[]
      }
    })
  })
})

export const { useGetGroupColumnsDataQuery } = groupColumnsApi
